// noinspection ES6UnusedImports
import React from 'react';
import WishlistHeart from './heart';

export default function WishlistHeartRecoWrapper({item}) {
    return (
        <WishlistHeart
            className="recommendation__add-to-wishlist-heart"
            digistyleId={item.productDigistyleId}
            articleNumber={item.itemNumber}
            promotion={
                typeof item.mainOrderNumberWithPromo !== 'undefined' ? item.mainOrderNumberWithPromo.slice(-2) : null
            }
            shopId={'0'}
            itemId={item.itemId}
            origin={'wishlist_carousel'}
            articlePrice={item.price}
            masterStyleId={''}
        />
    );
}
